import React from 'react';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { Typography, Button, ArrowToRight, Image, Section, Container } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var MainWrapper = styled(Primitive.div, {
  '.section-wrapper': {
    position: 'sticky',
    overflow: 'hidden',
    top: '56px',
    '@sm': {
      top: '72px'
    },
    '@md': {
      top: '88px'
    },
    '@xxl': {
      top: '96px'
    },
    '.content-wrapper': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '.top-overlay': {
        position: 'absolute',
        zIndex: 1,
        '&.layer-2': {
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          maxWidth: '600px',
          justifyContent: 'center',
          textAlign: 'center'
        }
      }
    }
  },
  '.image-wrapper': {
    '@xxl': {
      marginX: '-56px'
    },
    '&>span': {
      width: '100vw !important',
      height: 'calc(100vh - 56px) !important',
      '@sm': {
        height: 'calc(100vh - 72px) !important'
      },
      '@md': {
        height: 'calc(100vh - 88px) !important'
      },
      '@xxl': {
        height: 'calc(100vh - 96px) !important',
        width: 'auto !important',
        marginX: '-54px'
      },
      img: {
        objectFit: 'cover'
      }
    }
  }
});

var ImageCtaSection = function ImageCtaSection(_ref) {
  var props = _ref.props;

  var getOverlaySvg = function getOverlaySvg(index) {
    var overlaySvg = [/*#__PURE__*/_jsxs("svg", {
      width: "289",
      height: "368",
      viewBox: "0 0 289 368",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M123.633 179.877V367.325L81.3513 367.354L43.7734 195.794L123.633 179.877Z",
        fill: "#FF6575"
      }), /*#__PURE__*/_jsx("path", {
        d: "M251.888 154.582V367.326L209.606 367.354L165.832 171.56L251.888 154.582Z",
        fill: "#FF6575"
      }), /*#__PURE__*/_jsx("path", {
        d: "M85.9701 0.0286794L0 0L43.7738 195.794L85.9701 187.477V0.0286794Z",
        fill: "#FF6575"
      }), /*#__PURE__*/_jsx("path", {
        d: "M165.83 171.56L123.605 0H206.277V163.587L165.83 171.56Z",
        fill: "#FF6575"
      }), /*#__PURE__*/_jsx("path", {
        d: "M251.916 154.582L288.949 0H206.277V163.587L251.916 154.582Z",
        fill: "#FF6575"
      }), /*#__PURE__*/_jsx("path", {
        d: "M85.9727 0.0286794V187.477L165.833 171.56L123.636 0L85.9727 0.0286794Z",
        fill: "#FF6575"
      })]
    }), /*#__PURE__*/_jsxs("svg", {
      width: "492",
      height: "235",
      viewBox: "0 0 492 235",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M242.14 142.827C228.664 206.101 164.272 246.004 98.3529 231.995C32.4341 217.919 -10.1177 155.243 3.35813 91.9691C16.834 28.6951 81.226 -11.208 147.145 2.80123C213.064 16.8769 255.615 79.5533 242.14 142.827Z",
        fill: "#FFD02F"
      }), /*#__PURE__*/_jsx("path", {
        d: "M378.362 185.909C371.259 219.239 337.404 240.22 302.685 232.784C267.966 225.414 245.595 192.416 252.698 159.086C259.801 125.756 293.657 104.775 328.375 112.211C363.094 119.581 385.465 152.579 378.362 185.909Z",
        fill: "#FFD02F"
      }), /*#__PURE__*/_jsx("path", {
        d: "M490.616 86.8593C483.114 122.181 447.201 144.423 410.358 136.589C373.515 128.754 349.817 93.7643 357.384 58.4425C364.886 23.1206 400.799 0.878408 437.642 8.71296C474.418 16.5475 498.117 51.5374 490.616 86.8593Z",
        fill: "#FFD02F"
      }), /*#__PURE__*/_jsx("path", {
        d: "M311.05 49.6003C307.996 64.0079 293.259 73.1704 278.256 69.9171C263.187 66.7302 253.495 52.3889 256.615 37.9813C259.669 23.5737 274.406 14.4777 289.409 17.6646C304.411 20.8515 314.103 35.1927 311.05 49.6003Z",
        fill: "#FFD02F"
      }), /*#__PURE__*/_jsx("path", {
        d: "M486.62 199.392C483.567 213.8 468.83 222.962 453.827 219.709C438.758 216.522 429.066 202.181 432.186 187.773C435.239 173.366 449.976 164.27 464.979 167.457C479.982 170.71 489.674 184.985 486.62 199.392Z",
        fill: "#FFD02F"
      })]
    }), /*#__PURE__*/_jsxs("svg", {
      width: "302",
      height: "280",
      viewBox: "0 0 302 280",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M42.3514 0.531372H0.53125L51.4544 86.3279L0.53125 279.236H42.3514L135.737 104.483L42.3514 0.531372Z",
        fill: "#F7B2B2"
      }), /*#__PURE__*/_jsx("path", {
        d: "M125.446 0.531372H83.6797L134.549 104.483L83.6797 279.236H125.446L218.832 122.05L125.446 0.531372Z",
        fill: "#F7B2B2"
      }), /*#__PURE__*/_jsx("path", {
        d: "M208.556 0.531372H166.789L217.659 122.05L166.789 279.236H208.556L301.995 139.884L208.556 0.531372Z",
        fill: "#F7B2B2"
      })]
    })];

    if (index >= overlaySvg.length) {
      index = 0;
    }

    return overlaySvg[index];
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      pageTopInset: "1200",
      children: ''
    }), /*#__PURE__*/_jsx(MainWrapper, {
      children: props === null || props === void 0 ? void 0 : props.map(function (section, index) {
        var _section$cta, _section$cta2, _section$image, _section$image$deskto;

        return /*#__PURE__*/_jsx("div", {
          className: "section-wrapper",
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs("div", {
              className: "content-wrapper",
              children: [/*#__PURE__*/_jsx("div", {
                className: "top-overlay",
                children: getOverlaySvg(index)
              }), /*#__PURE__*/_jsxs("div", {
                className: "top-overlay layer-2",
                children: [/*#__PURE__*/_jsx(Typography, {
                  tone: "tertiary",
                  variant: "heading-2",
                  tag: "h3",
                  type: "heading",
                  offsetBottom: {
                    '@initial': '300',
                    '@md': '400'
                  },
                  renderChildrenAsHTML: true,
                  children: (section === null || section === void 0 ? void 0 : section.title) || ''
                }), /*#__PURE__*/_jsx(Button, {
                  href: section === null || section === void 0 ? void 0 : (_section$cta = section.cta) === null || _section$cta === void 0 ? void 0 : _section$cta.href,
                  endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
                  rounded: true,
                  size: "large",
                  variant: "primary",
                  children: section === null || section === void 0 ? void 0 : (_section$cta2 = section.cta) === null || _section$cta2 === void 0 ? void 0 : _section$cta2.text
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "image-wrapper",
                children: (section === null || section === void 0 ? void 0 : (_section$image = section.image) === null || _section$image === void 0 ? void 0 : (_section$image$deskto = _section$image.desktop) === null || _section$image$deskto === void 0 ? void 0 : _section$image$deskto.src) && /*#__PURE__*/_jsx(Image, {
                  image: section.image.desktop
                })
              })]
            })
          })
        }, 'image-cta-' + index);
      })
    })]
  });
};

export default ImageCtaSection;